import { render, staticRenderFns } from "./MbQuizWithBorder.vue?vue&type=template&id=51d3200d&scoped=true&"
import script from "./MbQuizWithBorder.vue?vue&type=script&lang=js&"
export * from "./MbQuizWithBorder.vue?vue&type=script&lang=js&"
import style0 from "./MbQuizWithBorder.vue?vue&type=style&index=0&id=51d3200d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d3200d",
  null
  
)

export default component.exports